import { render, staticRenderFns } from "./TranslatorOutput.vue?vue&type=template&id=7567504d&scoped=true"
import script from "./TranslatorOutput.vue?vue&type=script&lang=js"
export * from "./TranslatorOutput.vue?vue&type=script&lang=js"
import style0 from "./TranslatorOutput.vue?vue&type=style&index=0&id=7567504d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567504d",
  null
  
)

export default component.exports